import React from 'react';

export const About = () => {
    return (
        <>
            <h1>あいうえお</h1>
        </>
    );
};

export default About;